import Vue from "vue";

const state = {
  privateOffer: false,
  preApproval: false,
  MissedSLMModalInfo: {
    ShowModal: false
  }
};

const getters = {
  privateOffer(state) {
    return state.privateOffer;
  },
  preApproval(state) {
    return state.preApproval;
  }
};

const actions = {
  updateMissedSLMModalInfo(context, data) {
    context.commit("updateMissedSLMModalInfo", data);
  },
  updatePrivateOffer(context, data) {
    context.commit("updatePrivateOffer", data);
  },
  updatePreApproval(context, data) {
    context.commit("updatePreApproval", data);
  },
  async getAvailabilityCounts(context, request) {
    let response = await Vue.http.get("users/availabilityReport/count");
    return response && response.data ? response.data.Data : null;
  },
  async getAvailabilityReport(context, request) {
    let response = await Vue.http.post("users/availabilityReport", request);
    return response && response.data ? response.data.Data : null;
  },
  async updateUserAvailabilityStatus(context, request) {
    try {
      let response = await Vue.http.put(request.Url, request);
      return response && response.data ? response.data.Data : null;
    } catch (err) {
      return null;
    }
  },
  async getMonthToDateSLM(context, requestPayload) {
    return await Vue.http
      .get(`/pando/pandoalertreporting/dashboardMonthToDate?` + requestPayload)
      .catch(err => err.response);
  },
  async getCurrentTaskReport(context, requestPayload) {
    return await Vue.http
      .post(`/pando/pandoalertreporting/SLMDashboardSummary`, requestPayload)
      .catch(err => err.response);
  },
  async getSLMUserAvailability(context, requestPayload) {
    return await Vue.http
      .get(`/users/availabilityReport/count?` + requestPayload)
      .catch(err => err.response);
  },
  async getMissedOpportunitiesData(context, requestPayload) {
    return await Vue.http
      .get(
        `/pando/pandoalertreporting/missedOpportunitiesDetails?` +
          requestPayload
      )
      .catch(err => err.response);
  },
  async getSLMDashboardDetails(context, requestPayload) {
    return await Vue.http
      .post(`/pando/pandoalertreporting/slmdashboardDetails`, requestPayload)
      .catch(err => err.response);
  }
};

const mutations = {
  updatePrivateOffer(state, data) {
    state.privateOffer = data;
  },
  updatePreApproval(state, data) {
    state.preApproval = data;
  },
  updateMissedSLMModalInfo(state, data) {
    state.MissedSLMModalInfo = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/SLM.js